"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = __importDefault(require("@graphql-mesh/openapi"));
const OPENAPI_SPECIFICATION = 'https://www.weatherbit.io/static/swagger.json';
const BASE_URL = 'https://api.weatherbit.io/v2.0';
class WeatherbitHandler extends openapi_1.default {
    constructor({ name, config, cache, pubsub, }) {
        config.source = OPENAPI_SPECIFICATION;
        config.baseUrl = BASE_URL;
        config.qs = { key: config.token };
        super({ name, config, cache, pubsub });
    }
}
exports.default = WeatherbitHandler;
//# sourceMappingURL=handler.js.map